import {
  create_supply_company,
  update_supply_company,
  delete_supply_company,
  recover_supply_company,
  query_supply_company_list,
} from '@/api/mjstock-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstock/mjstock-supplycompany-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '供应商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商名称',
    },
    {
      type: 'input',
      name: 'phone',
      label: '联系电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写联系电话',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,

    name: null,
    phone: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '供应商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商名称',
    },
    {
      type: 'input',
      name: 'address',
      label: '供应商地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商地址',
    },
    {
      type: 'input',
      name: 'person_name',
      label: '供应商联系人',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商联系人',
    },
    {
      type: 'input',
      name: 'phone',
      label: '联系电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写联系电话',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入供应商名称' }],
    address: [{ required: true, message: '请填写供应商地址' }],
    person_name: [{ required: true, message: '请填写供应商联系人' }],
    phone: [{ required: true, message: '请填写联系电话' }],
  },
  model: reactive({
    org_id: current_org?.id,
    name: null,
    address: null,
    person_name: null,
    phone: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '供应商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商名称',
    },
    {
      type: 'input',
      name: 'address',
      label: '供应商地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商地址',
    },
    {
      type: 'input',
      name: 'person_name',
      label: '供应商联系人',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写供应商联系人',
    },
    {
      type: 'input',
      name: 'phone',
      label: '联系电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写联系电话',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入供应商名称' }],
    address: [{ required: true, message: '请填写供应商地址' }],
    person_name: [{ required: true, message: '请填写供应商联系人' }],
    phone: [{ required: true, message: '请填写联系电话' }],
  },
  model: reactive({
    org_id: current_org?.id,
    name: null,
    address: null,
    person_name: null,
    phone: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '供应商管理',
  addModalTitle: '新建供应商',
  updateTitle: '修改供应商',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    supplycompany_id: 'id',
  },
  delete: {
    supplycompany_id: 'id',
  },
  recover: {
    supplycompany_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    supplycompany_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '供应商编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '供应商名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '供应商地址',
    dataIndex: 'address',
    checked: true,
  },
  {
    title: '供应商联系人',
    dataIndex: 'person_name',
    checked: true,
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_supply_company_list,
    addData: create_supply_company,
    updateData: update_supply_company,
    removeData: delete_supply_company,
    recoverData: recover_supply_company,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
